// local
// export const uAPIlocal = 'http://'+window.location.hostname+':5001';
// online
export const uAPIlocal = 'https://book-mcu.biomedika.co.id';